<section class="page-section" id="services">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 text-center">
        <h2 class="section-heading text-uppercase">Services</h2>
        <h3 class="section-subheading">A little inside knowledge also helps</h3>
      </div>
    </div>
    <!-- <mat-accordion> -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <strong>Our services include the following:</strong>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul>
        <li>Efficient scanning of applicants according to a job description</li>
        <li>Advertising on behalf of our clients (free of charge)</li>
        <li>Thorough Reference checking on applicants</li>
        <li>Operational Area across Africa</li>
      </ul>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <strong>Validation of (for client’s account):</strong>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul>
        <li>ITC credit check</li>
        <li>Qualifications</li>
        <li>Criminal Record checking</li>
        <li>Driver’s Licence</li>
      </ul>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <strong>Tests available (on request, for client’s account):</strong>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul>
        <li>Psychometric and Personality testing</li>
        <li>Speed and accuracy Typing</li>
        <li>Financial Literacy</li>
        <li>Data capturing</li>
        <li>Microsoft Office Proficiency testing</li>
        <li>Translation testing</li>
        <li>Spelling testing</li>
        <li>Letter layout testing</li>
      </ul>
    </mat-expansion-panel>
    <!-- </mat-accordion> -->
  </div>
</section>
